import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class lists with clsx semantics + dedupe. Standard shadcn
 * utility; used across every styled component in this package.
 */
export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs));
}
